import React from 'react';
import {SeparatorVertical} from 'app/components/sharedReactComponents/Separator';

export function ActionButtonsSeparator() {
  return (
    <SeparatorVertical className="action-separator"/>
  );
}
